<template>
  <div class="recommendPage">
    <swiper :options="swiperOption" ref="mySwiper">
      <swiper-slide v-for="(item, idx) in bannerList" :key="idx" style="width: 100%;height: 100%;">
        <img :src="item.url" alt="" class="img">
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    
      <!-- <div class="swiper-button-prev" style="z-index:1000;" slot="button-prev" @lick="clickPage"></div>
      <div class="swiper-button-next" style="z-index:1000;" slot="button-next"></div> -->
  
    </swiper>
  </div>
</template>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
// import "swiper/dist/css/swiper.css";
var  index = 'https://qiniu.cxtrip.cc/liuxihe/index.jpg'
var  index2 = 'https://qiniu.cxtrip.cc/liuxihe/index2.jpg'
var  index3 = 'https://qiniu.cxtrip.cc/liuxihe/index3.jpg'
var  index4 = 'https://qiniu.cxtrip.cc/liuxihe/index4.jpg'
var  index5 = 'https://qiniu.cxtrip.cc/liuxihe/index5.jpg'
export default {
  name: 'HelloWorld',
  components: {
    swiper,
    swiperSlide
  },
  data () {
    return {
      bannerList: [
        {
          url: index
        },
        {
          url: index2
        },
        {
          url: index3
        }, 
        {
          url: index4
        },
        {
          url: index5
        },                
      ],
      swiperOption: {
        slidesPerView: 1,
        loop: true, // 循环模式
        autoplay: {
          delay: 120000,
          stopOnLastSlide: false,
          disableOnInteraction: false
        },
        speed: 2500,
        // effect: 'fade',
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true //允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        }
      }
      }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    }
  },
  mounted() {
    // current swiper instance
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    console.log("this is current swiper instance object", this.swiper);
    // this.swiper.slideTo(3, 1000, false);
  },
  created() {
    const vm = this;

  },
  methods: {
    clickPage () {
      console.log(123)
      this.swiper.slideTo(2, 1000, false);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  /* @import "index"; */
  .recommendPage {
    width: 100%;
    height: 100%;
  }
  /deep/ .swiper-container{
    height: 100%;
    width: 100%;
  }
  .img{
    width: 100%;
    height: 100%;
    object-fit:cover;
  }

  /deep/ .swiper-pagination-fraction, .swiper-pagination-custom, .swiper-container-horizontal > .swiper-pagination-bullets{
    bottom: 45px;
  }
  /deep/ .swiper-container-horizontal > .swiper-pagination-bullets .swiper-pagination-bullet{
    margin: 0 24px;
  }
  /deep/  .swiper-pagination-bullet{
    width: 16px;
    height: 16px;
    background-color: #ffffff;
    border: 2px solid #ffffff;
    opacity: 1;
  }
  /deep/  .swiper-pagination-bullet-active{
    border: 2px solid #44D7B6;
    background-color: #44D7B6;
  }

.active{
	border: 2px solid #44D7B6;
}
</style>